import { render, staticRenderFns } from "./CrudHeader.vue?vue&type=template&id=2563671c&scoped=true&"
import script from "./CrudHeader.vue?vue&type=script&lang=js&"
export * from "./CrudHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2563671c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2563671c')) {
      api.createRecord('2563671c', component.options)
    } else {
      api.reload('2563671c', component.options)
    }
    module.hot.accept("./CrudHeader.vue?vue&type=template&id=2563671c&scoped=true&", function () {
      api.rerender('2563671c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crud/CrudHeader.vue"
export default component.exports